export const messages = {
    "wrh-dashboard.nav-menu.item.resources": "資源",
    "wrh-dashboard.nav-menu.item.shared": "共用",
    "wrh-dashboard.nav-menu.item.backups": "備份",
    "wrh-dashboard.nav-menu.item.archives": "存檔",
    "wrh-dashboard.nav-menu.item.sync": "同步",
    "wrh-dashboard.nav-menu.item.mobile": "手機",
    "wrh-dashboard.nav-menu.item.account": "帳戶",
    "wrh-dashboard.search.input.hint": "搜尋",
    "wrh-dashboard.search.label.breadcrumb": "搜尋結果",
    "wrh-dashboard.search.message.empty": "沒有任何項目符合您的搜尋",
    "wrh-dashboard.side-bar.selected.title:plural": "已選擇 {count} 個項目 | 已選擇 {count} 個項目",
    "wrh-dashboard.side-bar.backup-type.entire-pc": "整部 PC",
    "wrh-dashboard.side-bar.backup-type.entire-mac": "整部 Mac",
    "wrh-dashboard.side-bar.backup-type.disk": "磁碟與磁碟分割",
    "wrh-dashboard.side-bar.backup-type.file": "檔案和資料夾",
    "wrh-dashboard.side-bar.backup-type.notarized": "已公證的檔案和資料夾",
    "wrh-dashboard.side-bar.backup-type.sync": "同步",
    "wrh-dashboard.side-bar.backup-type.archiving": "存檔",
    "wrh-dashboard.space-indicator.label.left": "剩餘 {spaceFree}",
    "wrh-dashboard.space-indicator.label.used": "{usedSpace} 已使用",
    "wrh-dashboard.space-indicator.label.unlimited": "無限制",
    "wrh-dashboard.backups-table.column.name": "名稱",
    "wrh-dashboard.backups-table.column.size": "大小",
    "wrh-dashboard.backups-table.column.version": "最後版本",
    "wrh-dashboard.backups-table.action.cleanup": "清理",
    "wrh-dashboard.backups-table.action.download-tool": "下載",
    "wrh-dashboard.backups-table.action.delete": "刪除",
    "wrh-dashboard.backups-table.action.downloads": "下載",
    "wrh-dashboard.backups-table.message.no-backups": "雲端中尚無備份",
    "wrh-dashboard.backups-table.message.no-archives": "雲端中尚無存檔",
    "wrh-dashboard.backups-table.message.no-syncs": "雲端中尚無同步",
    "wrh-dashboard.backups-sidebar.label.size": "大小",
    "wrh-dashboard.backups-sidebar.label.type": "類型",
    "wrh-dashboard.backups-sidebar.label.version": "最後版本",
    "wrh-dashboard.content-table.column.name": "名稱",
    "wrh-dashboard.content-table.column.versions": "版本",
    "wrh-dashboard.content-table.column.volumes": "磁碟區",
    "wrh-dashboard.content-table.column.path": "路徑",
    "wrh-dashboard.content-table.column.size": "大小",
    "wrh-dashboard.content-table.column.version": "最後版本",
    "wrh-dashboard.content-table.action.notary-verify": "驗證",
    "wrh-dashboard.content-table.action.notary-get-crt": "取得憑證",
    "wrh-dashboard.content-table.action.asign": "傳送以供簽章",
    "wrh-dashboard.content-table.action.versions": "版本",
    "wrh-dashboard.content-table.action.restore": "下載",
    "wrh-dashboard.content-table.action.share": "分享連結",
    "wrh-dashboard.content-table.label.size": "大小",
    "wrh-dashboard.content-table.label.created": "建立時間",
    "wrh-dashboard.content-table.label.modified": "修改時間",
    "wrh-dashboard.content-table.message.empty-folder": "此資料夾是空的",
    "wrh-dashboard.password-dialog-box.title.backup": "加密備份",
    "wrh-dashboard.password-dialog-box.title.archive": "加密存檔",
    "wrh-dashboard.password-dialog-box.message.backup": "請指定存取備份 {displayName} 的密碼",
    "wrh-dashboard.password-dialog-box.message.archive": "請指定存取存檔 {displayName} 的密碼",
    "wrh-dashboard.password-dialog-box.hint.password": "密碼",
    "wrh-dashboard.password-dialog-box.message.invalid-password": "密碼不正確",
    "wrh-dashboard.download-tool-dialog-box.message.title": "下載雲端備份",
    "wrh-dashboard.download-tool-dialog-box.message.first-header": "若要從備份下載檔案或資料夾：",
    "wrh-dashboard.download-tool-dialog-box.message.first-paragraph": "請按一下備份名稱，選擇備份中的檔案或資料夾，並在正確面板按下「下載」。",
    "wrh-dashboard.download-tool-dialog-box.message.second-header": "若要下載整個備份或備份集：",
    "wrh-dashboard.download-tool-dialog-box.message.second-paragraph": "請使用 {toolName}。若您還未完成，將需要下載工具。",
    "wrh-dashboard.download-tool-dialog-box.message.tool-name": "Acronis Cloud Backup Download　工具",
    "wrh-dashboard.download-tool-dialog-box.message": "下載工具",
    "wrh-dashboard.download-tool-dialog-box.gotIt": "瞭解",
    "wrh-dashboard.form.button.open": "開啟",
    "wrh-dashboard.form.button.close": "關閉",
    "wrh-dashboard.form.button.cancel": "取消",
    "wrh-dashboard.form.button.continue": "繼續",
    "wrh-dashboard.form.button.proceed": "繼續",
    "wrh-dashboard.form.button.delete": "刪除",
    "wrh-dashboard.form.button.done": "完成",
    "wrh-dashboard.form.button.retry": "重試",
    "wrh-dashboard.form.button.go-to-backups": "移至 [備份]",
    "wrh-dashboard.delete-dialog-box.title.backup": "刪除備份",
    "wrh-dashboard.delete-dialog-box.message.backup": "確定要從所有位置永久刪除選取的備份？備份的所有資料都將遭到破壞，無法還原。",
    "wrh-dashboard.delete-dialog-box.title.archive": "刪除存檔",
    "wrh-dashboard.delete-dialog-box.message.archive": "確定要從所有位置永久刪除選取的存檔？存檔的所有資料都將遭到破壞，無法還原。",
    "wrh-dashboard.delete-dialog-box.locked-error-message.backup": "已鎖定備份，以確保資料一致性。請使用備份終止所有作業 (例如瀏覽、還原、備份) 並再試一次。",
    "wrh-dashboard.delete-dialog-box.locked-error-message.archive": "已鎖定存檔，以確保資料一致性。請使用存檔終止所有作業 (例如瀏覽、還原、備份) 並再試一次。",
    "wrh-dashboard.cleanup-dialog-box.title": "{brandName} 清理",
    "wrh-dashboard.cleanup-dialog-box.checkbox.delete-versions-older-than": "刪除早於此時間的備份版本",
    "wrh-dashboard.cleanup-dialog-box.checkbox.delete-all-versions-except": "刪除所有舊的備份版本，但",
    "wrh-dashboard.cleanup-dialog-box.checkbox.delete-all-versions-recent-ones": "最近的備份版本除外",
    "wrh-dashboard.cleanup-dialog-box.combobox.time-unit.days": "天",
    "wrh-dashboard.cleanup-dialog-box.combobox.time-unit.months": "月",
    "wrh-dashboard.cleanup-dialog-box.combobox.time-unit.years": "年",
    "wrh-dashboard.cleanup-dialog-box.button.cleanup-now": "立即清理",
    "wrh-dashboard.cleanup-dialog-box.button.cleanup": "清理",
    "wrh-dashboard.cleanup-dialog-box.message": "您可以一次刪除所有舊的備份版本以釋出 {brandName} 中的空間。這將不會變更針對 True Image 中備份所設定的清理設定。",
    "wrh-dashboard.cleanup-dialog-box.message.cleanup-encrypted": "{encryptedBackupCount} / {totalBackupCount} 的備份經過加密。若要清理這些備份，您必須輸入密碼。請另外清理這些備份。",
    "wrh-dashboard.cleanup-confirm-dialog-box.title": "清理",
    "wrh-dashboard.cleanup-confirm-dialog-box.message": "確定要刪除此資料？您將無法復原此作業。",
    "wrh-dashboard.cleanup-encrypted-dialog-box.title": "{brandName} 清理",
    "wrh-dashboard.cleanup-encrypted-dialog-box.message": "您只有加密備份。若要清理這些備份，您必須輸入密碼。請另外清理這些備份。",
    "wrh-dashboard.cleanup-progress-dialog-box.title": "清理",
    "wrh-dashboard.cleanup-progress-dialog-box.message": "若要檢視清理作業的狀態，請將此視窗維持在開啟狀態。如果您關閉此視窗，清理作業將會在背景模式下繼續。",
    "wrh-dashboard.cleanup-progress-dialog-box.status": "{displayName} 正在清理...",
    "wrh-dashboard.cleanup-notification-dialog-box.title": "清理",
    "wrh-dashboard.cleanup-notification-dialog-box.message.success": "清理成功完成。更新雲端使用情況的相關資訊可能需要一些時間。",
    "wrh-dashboard.cleanup-notification-dialog-box.message.fail": "清理失敗",
    "wrh-dashboard.cleanup-notification-dialog-box.message.box-locked": "當備份正在進行時，無法執行清理。請稍候再試。",
    "wrh-dashboard.cleanup-notification-dialog-box.message.wait": "清理仍在背景模式下執行。請等到清理完成。",
    "wrh-dashboard.shared-content-table.column.name": "名稱",
    "wrh-dashboard.shared-content-table.column.location": "位置",
    "wrh-dashboard.shared-content-table.column.source": "來源",
    "wrh-dashboard.shared-content-table.column.days": "天",
    "wrh-dashboard.shared-content-table.column.downloads": "下載",
    "wrh-dashboard.shared-content-table.column.shared": "共用於",
    "wrh-dashboard.shared-content-table.label.shared": "共用於",
    "wrh-dashboard.shared-content-table.label.backup": "來源",
    "wrh-dashboard.shared-content-table.action.share": "分享連結",
    "wrh-dashboard.shared-content-table.action.settings": "連結設定",
    "wrh-dashboard.shared-content-table.action.delete": "刪除連結",
    "wrh-dashboard.shared-content-table.action.delete-selected": "刪除連結",
    "wrh-dashboard.account-page.message.used-space": "{brandName}：可用空間 {spaceFree}，共 {totalSpace}",
    "wrh-dashboard.account-page.message.used-unlimited-space": "{brandName}：無限制的空間",
    "wrh-dashboard.account-page.button.sign-out": "登出",
    "wrh-dashboard.account-page.button.clean-up": "清理",
    "wrh-dashboard.account-page.button.manage-subscription": "管理授權",
    "wrh-dashboard.account-page.message.subscription.active": "您的 {brandName} 空間授權將過期於",
    "wrh-dashboard.account-page.message.subscription.trial": "{brandName} 試用版作用中，直到",
    "wrh-dashboard.account-page.message.subscription.expired": "您的 {brandName} 空間授權已過期於",
    "wrh-dashboard.account-page.message.worm-status.storage-full": "您的 {brandName} 儲存空間已滿。您無法將資料備份或存檔至雲端。",
    "wrh-dashboard.account-page.message.worm-status.less-than": "低於 {percent}% 可用。您即將無法使用 {brandName}。",
    "wrh-dashboard.notary.verify.view.status.downloading": "正在下載...",
    "wrh-dashboard.notary.verify.view.status.validating": "正在驗證...",
    "wrh-dashboard.notary.verify.view.status.pending": "正在等候憑證...",
    "wrh-dashboard.notary.verify.view.status.fail": "憑證不相符...",
    "wrh-dashboard.notary.verify.view.button.get-crt": "取得憑證",
    "wrh-dashboard.notary.verify.view.file-info.name": "名稱",
    "wrh-dashboard.notary.verify.view.file-info.signed-by": "簽署者",
    "wrh-dashboard.notary.verify.view.file-info.date-backed-up": "備份日期",
    "wrh-dashboard.notary.verify.view.file-info.date-notarized": "公證日期",
    "wrh-dashboard.notary.verify.view.button.cancel": "取消",
    "wrh-dashboard.notary.verify.view.button.done": "完成",
    "wrh-dashboard.notary.warning.unsupported.browser.version": "不支援的瀏覽器版本",
    "wrh-dashboard.versions-dialog-box.title": "{fileName} 的版本",
    "wrh-dashboard.asign-dialog-box.title": "傳送以供簽章",
    "wrh-dashboard.asign-dialog-box.message": "檔案版本已共用，但是如果沒有檔案的連結，就無法檢視該檔案。繼續進行 ASign 以加入簽章並分享連結。",
    "wrh-dashboard.asign-dialog-box.button.show-signed-file-details": "顯示檔案詳細資料",
    "wrh-dashboard.shared-link-dialog-box.share-view.button.copy": "複製連結",
    "wrh-dashboard.shared-link-dialog-box.share-view.button.manage": "連結設定",
    "wrh-dashboard.shared-link-dialog-box.share-view.message": "擁有此連結的任何人都可以檢視資料的最後版本。",
    "wrh-dashboard.shared-link-dialog-box.share-view.label.shared": "共用於 {creationDate}",
    "wrh-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "已複製連結",
    "wrh-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "連結複製錯誤",
    "wrh-dashboard.shared-link-dialog-box.delete-view.title": "刪除連結",
    "wrh-dashboard.shared-link-dialog-box.delete-view.message": "此連結將不再適用於擁有該連結的任何人。",
    "wrh-dashboard.shared-link-dialog-box.delete-selected-view.title": "刪除連結",
    "wrh-dashboard.shared-link-dialog-box.delete-selected-view.message": "這些連結將不再適用於擁有這些連結的任何人",
    "wrh-dashboard.shared-link-dialog-box.manage-view.title": "連結設定",
    "wrh-dashboard.shared-link-dialog-box.manage-view.button.delete": "刪除連結",
    "wrh-dashboard.shared-link-dialog-box.manage-view.button.apply": "完成",
    "wrh-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "密碼",
    "wrh-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "重設密碼",
    "wrh-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "密碼保護",
    "wrh-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "使用密碼保護此連結",
    "wrh-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "到期",
    "wrh-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "下載限制",
    "wrh-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "在 {splitMarker} 天後停用此連結 | 在 {splitMarker} 天後停用此連結",
    "wrh-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "在 {splitMarker} 下載後停用此連結 | 在 {splitMarker} 下載後停用此連結",
    "wrh-dashboard.page-not-found.title": "找不到頁面",
    "wrh-dashboard.page-not-found.message.main": "找不到您要尋找的頁面。",
    "wrh-dashboard.page-not-found.message.description": "此連結可能過時，或者您可以輸入錯誤的位址。",
    "wrh-dashboard.page-not-found.message.error": "錯誤碼:404",
    "wrh-dashboard.server-error.title": "伺服器無法使用",
    "wrh-dashboard.server-error.message": "伺服器目前無法使用。請稍候再試。",
    "wrh-dashboard.server-error.message.error": "錯誤碼:500"
};
